import React from 'react';
import { styled, SvgIcon, Currency } from '@teko/ui';
import { space } from 'styled-system';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EditIcon = styled(SvgIcon)(({ theme }) => `
    width: 1.25rem;
    height: 1.25rem;
    margin-left: 0.25rem;
    background-color: ${theme == null ? void 0 : theme.colors.link500};
  `);
const Wrapper = styled.div(space, () => `
    display: flex;
    justify-content: space-between;
  `);
const PriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
  flex-direction: column;
`;
const Price = styled(Currency)(({ variant, theme }) => `
    font-size: 1rem;
    font-weight: 500;
    color: ${variant === "primary" ? theme == null ? void 0 : theme.brand.primary : theme == null ? void 0 : theme.colors.dark};
    font-weight: bold;
  `);
const DiscountWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const ListedPrice = styled(Currency)(({ theme }) => `
  text-decoration: line-through;
  color: ${theme == null ? void 0 : theme.colors.gray130};
  font-size: 0.75rem;
`);
const PriceContainer = styled.div`
  display: flex;
  align-items: center;
`;
const ProductPrice = (_a) => {
  var _b = _a, {
    price,
    className,
    listedPrice = 0,
    consultationServiceFee = 0,
    variant = "primary",
    isPriceEditable = false,
    onEditPrice
  } = _b, props = __objRest(_b, [
    "price",
    "className",
    "listedPrice",
    "consultationServiceFee",
    "variant",
    "isPriceEditable",
    "onEditPrice"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    className
  }), /* @__PURE__ */ React.createElement(PriceWrapper, null, (price != null ? price : 0) >= 0 && /* @__PURE__ */ React.createElement(PriceContainer, null, /* @__PURE__ */ React.createElement(Price, {
    value: price,
    variant,
    className: "product-price__price"
  }), isPriceEditable && /* @__PURE__ */ React.createElement(EditIcon, {
    name: "edit",
    onClick: onEditPrice
  })), !!listedPrice && !!price && listedPrice !== price - consultationServiceFee && /* @__PURE__ */ React.createElement(DiscountWrapper, null, /* @__PURE__ */ React.createElement(ListedPrice, {
    value: listedPrice,
    className: "product-price__listed-price"
  }))));
};

export { ProductPrice };
